import { NgrxFormsModule } from 'ngrx-forms';

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { PushPipe } from '@ngrx/component';

import { NgrxFormsErrorPipe } from './pipes/ngrx-forms-errors-pipe';

@NgModule({
  imports: [CommonModule, NgrxFormsModule, PushPipe, ReactiveFormsModule],
  exports: [NgrxFormsModule, NgrxFormsErrorPipe, PushPipe, ReactiveFormsModule],
  declarations: [NgrxFormsErrorPipe],
})
export class AppFormsModule {}
